module.exports = __webpack_public_path__ + "img/org-logo.d12677a0.png";